import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { MapPin, Mail, Facebook } from "lucide-react";
import { cityData } from "@/data/cityData";

const Footer = () => {
  const openCookieSettings = () => {
    import('@/components/CookieConsent').then(module => {
      module.openCookieSettings();
    });
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-5 gap-8 mb-12">
          <div className="md:col-span-1">
            <Logo size="sm" className="mb-4" />
            <p className="text-muted-foreground text-sm leading-relaxed">
            Vergelijk gratis verhuisoffertes van erkende verhuisbedrijven en bespaar tot 40% op uw verhuizing.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Verhuizen per stad</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/verhuizen/amsterdam" className="hover:text-primary transition-colors">Verhuisbedrijf Amsterdam</Link></li>
              <li><Link to="/verhuizen/rotterdam" className="hover:text-primary transition-colors">Verhuisbedrijf Rotterdam</Link></li>
              <li><Link to="/verhuizen/den-haag" className="hover:text-primary transition-colors">Verhuisbedrijf Den Haag</Link></li>
              <li><Link to="/verhuizen/utrecht" className="hover:text-primary transition-colors">Verhuisbedrijf Utrecht</Link></li>
              <li><Link to="/verhuizen/eindhoven" className="hover:text-primary transition-colors">Verhuisbedrijf Eindhoven</Link></li>
              <li><Link to="/verhuizen/groningen" className="hover:text-primary transition-colors">Verhuisbedrijf Groningen</Link></li>
              <li><Link to="/verhuizen/breda" className="hover:text-primary transition-colors">Verhuisbedrijf Breda</Link></li>
              <li><Link to="/verhuizen/tilburg" className="hover:text-primary transition-colors">Verhuisbedrijf Tilburg</Link></li>
              <li><Link to="/verhuizen/arnhem" className="hover:text-primary transition-colors">Verhuisbedrijf Arnhem</Link></li>
              <li><Link to="/verhuizen/amstelveen" className="hover:text-primary transition-colors">Verhuisbedrijf Amstelveen</Link></li>
              <li><Link to="/verhuisbedrijven" className="hover:text-primary transition-colors font-medium text-primary">Alle verhuisbedrijven →</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Verhuisoffertes</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/verhuisoffertes" className="hover:text-primary transition-colors font-medium text-primary">Verhuisoffertes vergelijken</Link></li>
              <li><Link to="/verhuisoffertes/amsterdam" className="hover:text-primary transition-colors">Offertes Amsterdam</Link></li>
              <li><Link to="/verhuisoffertes/rotterdam" className="hover:text-primary transition-colors">Offertes Rotterdam</Link></li>
              <li><Link to="/verhuisoffertes/den-haag" className="hover:text-primary transition-colors">Offertes Den Haag</Link></li>
              <li><Link to="/verhuisoffertes/utrecht" className="hover:text-primary transition-colors">Offertes Utrecht</Link></li>
              <li><Link to="/verhuisoffertes/eindhoven" className="hover:text-primary transition-colors">Offertes Eindhoven</Link></li>
              <li><Link to="/verhuisoffertes/groningen" className="hover:text-primary transition-colors">Offertes Groningen</Link></li>
              <li><Link to="/verhuisoffertes/breda" className="hover:text-primary transition-colors">Offertes Breda</Link></li>
              <li><Link to="/verhuisoffertes/tilburg" className="hover:text-primary transition-colors">Offertes Tilburg</Link></li>
              <li><Link to="/verhuisoffertes/arnhem" className="hover:text-primary transition-colors">Offertes Arnhem</Link></li>
              <li><Link to="/quote" className="hover:text-primary transition-colors font-medium text-primary">Direct offerte aanvragen →</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-semibold mb-4">Handige tools & gidsen</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/verhuiskosten" className="hover:text-primary transition-colors">Verhuiskosten 2026</Link></li>
              <li><Link to="/verhuistips" className="hover:text-primary transition-colors">Verhuistips</Link></li>
              <li><Link to="/verhuischecklist" className="hover:text-primary transition-colors">Verhuischecklist</Link></li>
              <li><Link to="/volume-calculator" className="hover:text-primary transition-colors">Volume Calculator</Link></li>
              <li><Link to="/adreswijziging-doorgeven" className="hover:text-primary transition-colors">Adreswijziging doorgeven</Link></li>
              <li><Link to="/energiecontract-verhuizen" className="hover:text-primary transition-colors">Energiecontract verhuizen</Link></li>
              <li><Link to="/verzekeringen-aanpassen" className="hover:text-primary transition-colors">Verzekeringen aanpassen</Link></li>
              <li><Link to="/goedkoop-verhuizen" className="hover:text-primary transition-colors">Goedkoop verhuizen</Link></li>
              <li><Link to="/studentenverhuizing" className="hover:text-primary transition-colors">Studentenverhuizing</Link></li>
              <li><Link to="/senioren-verhuizen" className="hover:text-primary transition-colors">Senioren verhuizen</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Verhuisblog</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Specialistisch</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/piano-verhuizen" className="hover:text-primary transition-colors">Piano verhuizen</Link></li>
              <li><Link to="/kluis-verhuizen" className="hover:text-primary transition-colors">Kluis verhuizen</Link></li>
              <li><Link to="/kunst-verhuizen" className="hover:text-primary transition-colors">Kunst verhuizen</Link></li>
              <li><Link to="/aquarium-verhuizen" className="hover:text-primary transition-colors">Aquarium verhuizen</Link></li>
              <li><Link to="/verhuizen-naar-belgie" className="hover:text-primary transition-colors">Verhuizen naar België</Link></li>
              <li><Link to="/verhuizen-naar-duitsland" className="hover:text-primary transition-colors">Verhuizen naar Duitsland</Link></li>
              <li><Link to="/over-ons" className="hover:text-primary transition-colors">Over ons</Link></li>
              <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>

            <h4 className="font-semibold mt-6 mb-3">Contact</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>Amsterdam, Nederland</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 shrink-0" />
                <a href="mailto:info@verhuismatch.com" className="hover:text-primary transition-colors">
                  info@verhuismatch.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Facebook className="w-4 h-4 shrink-0" />
                <a 
                  href="https://www.facebook.com/profile.php?id=61586324802343" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>


        <div className="border-t border-border/50 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
            <Link to="/voor-verhuizers" className="hover:text-foreground transition-colors">
              Voor Verhuizers
            </Link>
            <span className="text-border">•</span>
            <Link to="/verhuizer-aanmelden" className="hover:text-foreground transition-colors">
              Aanmelden
            </Link>
            <span className="text-border">•</span>
            <Link to="/affiliate" className="hover:text-foreground transition-colors">
              Affiliate
            </Link>
            <span className="text-border">•</span>
            <Link to="/pers" className="hover:text-foreground transition-colors">
              Pers & Media
            </Link>
            <span className="text-border">•</span>
            <Link to="/favorieten" className="hover:text-foreground transition-colors">
              Favorieten
            </Link>
            <span className="text-border">•</span>
            <Link to="/vergelijken" className="hover:text-foreground transition-colors">
              Vergelijken
            </Link>
            <span className="text-border">•</span>
            <Link to="/auteur/jan-de-vries" className="hover:text-foreground transition-colors">
              Auteur
            </Link>
            <span className="text-border">•</span>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <span className="text-border">•</span>
            <Link to="/voorwaarden" className="hover:text-foreground transition-colors">
              Voorwaarden
            </Link>
            <span className="text-border">•</span>
            <Link to="/cookies" className="hover:text-foreground transition-colors">
              Cookies
            </Link>
            <span className="text-border">•</span>
            <Link to="/disclaimer" className="hover:text-foreground transition-colors">
              Disclaimer
            </Link>
            <span className="text-border">•</span>
            <Link to="/privacy-bedrijven" className="hover:text-foreground transition-colors">
              Privacy Bedrijven
            </Link>
            <span className="text-border">•</span>
            <Link to="/voorwaarden-bedrijven" className="hover:text-foreground transition-colors">
              Voorwaarden Bedrijven
            </Link>
            <span className="text-border">•</span>
            <button 
              onClick={openCookieSettings}
              className="hover:text-foreground transition-colors"
            >
              Cookie instellingen
            </button>
            <span className="text-border">•</span>
            <Link to="/auth" className="hover:text-foreground transition-colors">
              Inloggen
            </Link>
          </div>
          <p className="text-sm text-muted-foreground text-center mt-4">
            © 2026 VerhuisMatch
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;